import useCustomApi from '../../hooks/use-custom-api'
import {useQuery} from '@tanstack/react-query'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useGetCategoriesData = () => {
    const {site, locale} = useMultiSite()

    const api = useCustomApi()
    const countryCode = locale?.id.replace('-', '_') || 'en'

    const {data: categoriesData} = useQuery(
        ['categoriesData'],
        async () => {
            // even though it says menu data, it's actually all the categories data
            const data = await api.getCustomObject(
                'categoriesMenuData',
                'categoriesMenuData_' + (countryCode || 'en'),
            )
            if (data?.c_categoriesData) {
                const parsedData = JSON.parse(data?.c_categoriesData)
                Object.keys(parsedData).forEach((key) => {
                    parsedData[key].url = parsedData[key].url
                        .replace(`/s/${site.id}`, '')
                        .replace(`/${locale.alias}/`, '/')
                })
                return parsedData
            }

            return null
        },
        {staleTime: Infinity},
    )

    return categoriesData
}
